import { api, extractApiErrorMessage } from '../../api/client';
import { ROUTES } from '../../api/routes';

type BondingApiRequestOptions = {
  bearerToken?: string;
};

export type CreateDeviceBondingSessionInput = {
  fingerprint: string;
};

export type DeviceBondingSessionResponse = {
  sessionId: string;
  bondingUrl?: string;
  expiraEm?: string;
  status?: string;
  currentStep?: string;
};

export type SecurityConfigResponse = {
  trustLevel?: number;
  [key: string]: unknown;
};

function authSurfaceConfig(options?: BondingApiRequestOptions) {
  const config: {
    headers: { 'X-AC-Use-Bearer': 'true' };
    _acBearerToken?: string;
  } = {
    headers: {
      'X-AC-Use-Bearer': 'true',
    },
  };
  const bearerToken = options?.bearerToken?.trim();
  if (bearerToken) {
    config._acBearerToken = bearerToken;
  }
  return config;
}

function rethrowUnauthorized(err: unknown) {
  if ((err as { response?: { status?: number } })?.response?.status === 401) {
    throw err;
  }
}

export async function createDeviceBondingSession(
  input: CreateDeviceBondingSessionInput,
  options?: BondingApiRequestOptions,
): Promise<DeviceBondingSessionResponse> {
  try {
    const { data } = await api.post<DeviceBondingSessionResponse>(
      ROUTES.auth.qrLink,
      input,
      authSurfaceConfig(options),
    );
    return data;
  } catch (err) {
    rethrowUnauthorized(err);
    throw new Error(extractApiErrorMessage(err, 'Falha ao gerar sessao QR.'));
  }
}

export async function getActiveDeviceBondingSession(
  options?: BondingApiRequestOptions,
): Promise<DeviceBondingSessionResponse | null> {
  try {
    const { data } = await api.get<DeviceBondingSessionResponse | null>(
      ROUTES.auth.activeSession,
      authSurfaceConfig(options),
    );
    return data;
  } catch (err) {
    rethrowUnauthorized(err);
    throw new Error(extractApiErrorMessage(err, 'Falha ao consultar sessao ativa.'));
  }
}

export async function getSecurityConfig(
  options?: BondingApiRequestOptions,
): Promise<SecurityConfigResponse> {
  try {
    const { data } = await api.get<SecurityConfigResponse>(
      ROUTES.security.config,
      authSurfaceConfig(options),
    );
    return data;
  } catch (err) {
    rethrowUnauthorized(err);
    throw new Error(extractApiErrorMessage(err, 'Falha ao consultar configuracao de seguranca.'));
  }
}

export async function desktopDisconnectDeviceBonding(
  sessionId: string,
  options?: BondingApiRequestOptions,
): Promise<unknown> {
  try {
    const { data } = await api.post(
      ROUTES.auth.sessionDesktopDisconnect(sessionId),
      {},
      authSurfaceConfig(options),
    );
    return data;
  } catch (err) {
    rethrowUnauthorized(err);
    throw new Error(extractApiErrorMessage(err, 'Falha ao desconectar celular.'));
  }
}
